module.exports = __webpack_public_path__ + "static/SSTArabic-Roman-ff4c9446d8c65c67f3dab8173908e5d2.otf";